import React, { useState } from 'react';
import './modal.css';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import { toast } from 'react-toastify';
import useSubmitLock from '../../utils/useSubmitLock';

const QuickAddModal = ({ label, fields, onAdd }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const field = fields.find((f) => f.name === name);
    const transformed = field?.transform ? field.transform(value) : value;
    setFormData((prev) => ({ ...prev, [name]: transformed }));
  };

  const handleSave = async () => {
    await runWithSubmitLock(async () => {
      const hasEmptyFields = fields.some((field) => {
        const value = formData[field.name];
        if (field.type === 'number') {
          return value === '' || isNaN(Number(value));
        }
        return !value || value.toString().trim() === '';
      });

      if (hasEmptyFields) {
        toast.warning('Por favor, preencha todos os campos.');
        return;
      }

      await onAdd(formData);
      setFormData({});
      setIsOpen(false);
    });
  };

  return (
    <div>
      <button className='btn-open-quick' type="button" onClick={() => setIsOpen(true)}>
        <img src={PlusCircle} alt='Botão' />
      </button>
      {isOpen && (
        <div className="quick-modal">
          <div className="quick-modal-content">
            <h4 className='h4-title'>Adicionar {label}</h4>
            {fields.map((field) => (
              <input
                key={field.name}
                className="quick-modal-input"
                type={field.type || 'text'}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={handleChange}
                placeholder={field.placeholder}
                required
              />
            ))}
            <div className="quick-modal-buttons">
              <button onClick={handleSave} className="quick-modal-button" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
              <button onClick={() => setIsOpen(false)} className="quick-modal-button-cancel" disabled={isSubmitting}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickAddModal;
